import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Inject,
  Input
} from '@angular/core';

import { iconToken } from '../icon-provider';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * this component is your 'render-this-svg-here-inline' solution. Use it as
 * <app-icon name="cart" class="text-red" /> to render the cart icon with class text-red styles
 */
@Component({
  selector: 'app-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: '',
  styles: [
    `
      :host {
        display: inline-block;
        box-sizing: initial;
        width: 1em; /* em makes it scale relative to the surrounding font-size -> autoscaling to font*/
        height: 1em;
        vertical-align: baseline;
        /* stroke: currentColor; */
        stroke: none;
        fill: currentColor;
        ::ng-deep svg {
          width: inherit;
          height: inherit;
          display: block;
        }
      }
    `
  ]
})
export class IconComponent {
  // used to specify which icon to use. will look it up in the provided icons in the iconToken
  @Input() set name(name: string) {
    for (const iconPack of this.icons) {
      if (iconPack[name]) {
        this.template = this.sanitizer.bypassSecurityTrustHtml(iconPack[name]);
        return;
      }
    }
    console.warn(
      `No icon with the name "${name}" found. Did you forget to update your provider or do you have a typo?`
    );
  }

  // so we can easily set the template
  @HostBinding('innerHTML') template?: SafeHtml;

  @HostBinding('style.height') @Input() height: string; // = '1rem';
  @HostBinding('style.width') @Input() width: string; // = '1rem';
  @HostBinding('style.vertical-align') @Input() alignment: string; // = 'baseline';

  // check provider for your iconToken in this module or in your standalone component
  constructor(
    @Inject(iconToken) private readonly icons: Record<string, string>[],
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {
    this.cdr.detach();
  }
}
